var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col items-center mt-4 w-full h-full"},[_c('div',{staticClass:"piechart w-24 h-24",style:({'background-image': 'conic-gradient(#f87171 0'+_vm.culculatePercentDegrees(_vm.costs,_vm.income)+'deg, #22c55e 0)'})})])
}
var staticRenderFns = []

export { render, staticRenderFns }